"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutContent = void 0;
var react_1 = __importStar(require("react"));
var system_1 = require("../system");
var utils_1 = require("../utils");
var Box_1 = require("./Box");
var Grid_1 = require("./Grid");
var useLayoutContentStyles = (0, system_1.makeStyles)(function (theme) { return ({
    content: {
        position: 'relative',
        marginLeft: function (_a) {
            var gridType = _a.gridType;
            return -theme.go.schemes.spacing[gridType].spaceUnit;
        },
        marginRight: function (_a) {
            var gridType = _a.gridType;
            return -theme.go.schemes.spacing[gridType].spaceUnit;
        },
        overflow: 'hidden',
    },
    scrollContainer: {
        overflow: 'auto',
        height: '100%',
        width: '100%',
        paddingLeft: function (_a) {
            var gridType = _a.gridType;
            return theme.go.schemes.spacing[gridType].spaceUnit;
        },
        paddingRight: function (_a) {
            var gridType = _a.gridType;
            return theme.go.schemes.spacing[gridType].spaceUnit;
        },
    },
    withActions: {
        '$scrollContainer&': {
            height: 'calc(100% - 80px)',
        },
    },
    actionsPanel: {
        zIndex: 10,
        position: 'absolute',
        bottom: 0,
        height: 100,
        left: 0,
        right: 0,
    },
    actionsPanelContent: {
        position: 'relative',
        height: 80,
        boxShadow: theme.go.schemes.effects.topShadow,
        backgroundColor: theme.go.schemes.colors.system.BgMain,
        width: '100%',
    },
}); });
exports.LayoutContent = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, classes = _a.classes, className = _a.className, renderActions = _a.renderActions;
    var gridType = (0, react_1.useContext)(Grid_1.GridContext).type;
    var _b = useLayoutContentStyles({ gridType: gridType }), content = _b.content, scrollContainer = _b.scrollContainer, withActions = _b.withActions, actionsPanel = _b.actionsPanel, actionsPanelContent = _b.actionsPanelContent;
    var actionsEl = renderActions ? renderActions() : null;
    return (react_1.default.createElement(Box_1.Box, { className: (0, utils_1.cn)(content, classes === null || classes === void 0 ? void 0 : classes.root, className) },
        react_1.default.createElement(Box_1.Box, { ref: ref, className: (0, utils_1.cn)(scrollContainer, actionsEl ? withActions : undefined, classes === null || classes === void 0 ? void 0 : classes.content) }, children),
        !!actionsEl && (react_1.default.createElement(Box_1.Box, { className: actionsPanel },
            react_1.default.createElement(Box_1.Box, { className: actionsPanelContent, alignSelf: "flex-end", alignItems: "center", pl: "L", pr: "L" },
                actionsEl,
                ' ')))));
});
